<template>
  <div>
    <header v-if="!isMobiledevice()" class="headers" style="box-shadow:none;">
      <div class="containers head_desk">
        <div class="logo" v-if="!isMobiledevice()">
          <a v-if="!isposp" class="logopb"  href="https://www.policybazaar.com" aria-label="pb logo"></a>
          <a v-if="isposp" class="logopb" :href="`https://www.policybazaar.com${utmSource ? ('?utm_source=' + utmSource) : ''}`" aria-label="pb logo">
            <!-- <img
              style="max-height:33px;margin-top:0px"
              v-if="isposp"
              alt="logo"
              title="Policy Bazaar"
              src="https://static.pbcdn.in/term-cdn/images/vue/pbp_web_logo.svg"
            /> -->
          </a>
        </div>
        <div class="claim-ratio" v-if="!isposp">
          <a target="_blank" rel="noopener" v-bind:href="getTermDecalLik">
            <i class="icons"></i>
            Claim assistance
          </a>
        </div>
        <div class="quotetop-rights" v-if="!isposp">
          <div @click="openTalkToExp = true;" class="pbcontact" v-on:mouseleave="openTalkToExp = false">
            <i class="call_icon"></i>
            <i class="phone_icon">Call us</i>
            <div
              class="talkExpertPopUpBody"
              v-bind:class="{'show':openTalkToExp}"
            >
              <i class="topIcon"></i>
              <div class="d-flex flex-column">
                <div class="expertPopupInnerBody">
                  <div class="expertPopUpDetails pb-2 mb-2">
                    You can reach us directly on the
                    <br />below toll-free numbers
                  </div>
                  <div class="expertPopUpBody">
                    <div
                      class="expertPopUpDiv border-bottom-0 d-flex align-items-center mb-2"
                      v-if="isNri"
                    >
                      <div
                        class="expertPopUpIcons d-flex justify-content-center align-items-center mr-2"
                      >
                        <img
                          alt="Term Insurance"
                          src="https://static.pbcdn.in/term-cdn/images/images/globalIcon.svg"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div class="expertPopUpIconsTxt">
                        For NRI’s
                        <div class="expertPopUpCallingNumber">
                          <a href="tel:+91 124-6656508">+91 124-6656508</a>
                        </div>
                      </div>
                    </div>
                    <div class="expertPopUpDiv d-flex align-items-center pb-2 mb-2">
                      <div
                        class="expertPopUpIcons d-flex justify-content-center align-items-center mr-2"
                      >
                        <img
                          alt="Term Insurance"
                          src="https://static.pbcdn.in/term-cdn/images/images/headSetIcon.svg"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div class="expertPopUpIconsTxt">
                        Looking To Buy ( Sales)
                        <div class="expertPopUpCallingNumber">
                          <a href="tel:1800-419-7713">1800-419-7713</a>
                        </div>
                      </div>
                    </div>
                    <div class="expertPopUpDiv d-flex align-items-center pb-2 mb-2">
                      <div
                        class="expertPopUpIcons d-flex justify-content-center align-items-center mr-2"
                      >
                        <img
                          alt="Term Insurance"
                          src="https://static.pbcdn.in/term-cdn/images/images/telePhoneIcon.svg"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div class="expertPopUpIconsTxt">
                        Have Already Paid (Service)
                        <div class="expertPopUpCallingNumber">
                          <a href="tel:1800-258-5970">1800-258-5970</a>
                        </div>
                      </div>
                    </div>
                    <div
                      class="expertPopUpDiv border-bottom-0 d-flex align-items-center mb-2"
                      v-if="!isNri"
                    >
                      <div
                        class="expertPopUpIcons d-flex justify-content-center align-items-center mr-2"
                      >
                        <img
                          alt="Term Insurance"
                          src="https://static.pbcdn.in/term-cdn/images/images/globalIcon.svg"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div class="expertPopUpIconsTxt">
                        For NRI’s
                        <div class="expertPopUpCallingNumber">
                          <a href="tel:+91 124-6656508">+91 124-6656508</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="expertPopUpBtmTxt text-center">
                    Office Hours - 10:00 AM to 09:00 PM (IST)
                    <br />Use Registered No. Only*
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <header v-if="!isSpouse" class="header-mob" v-bind:class="{'womenHeaader':isWomen}">
      <div class="logo">
        <a class="logoimg" href="https://www.policybazaar.com" aria-label="pb logo"></a>
      </div>
      <div class="title">{{isCrmLink?'Term of the day':'Term Insurance'}}</div>
      <div @click="openTalkToExp = true;" class="quotetop-rights">
        <em class="mobile_call">
          <img
            v-if="isWomen"
            alt="Term Insurance"
            src="https://static.pbcdn.in/term-cdn/images/images/call_us_1.svg"
            width="17"
            height="16"
          />
          <img
            v-if="!isWomen"
            alt="Term Insurance"
            src="https://static.pbcdn.in/term-cdn/images/images/Call_icon.svg"
          />
          <span v-if="!isWomen" class="txt">Call us</span>
          <span v-if="isWomen" class="txt">Talk to Expert</span>

          <div
            class="talkExpertPopUpBody"
            v-bind:class="{'show' : openTalkToExp }"
            v-on:mouseleave="openTalkToExp = false"
          >
            <span class="close" @click="closeTalkToExp"></span>
            <i class="topIcon"></i>
            <div class="d-flex flex-column">
              <div class="expertPopupInnerBody">
                <div class="expertPopUpDetails pb-2 mb-2">
                  You can reach us directly on the
                  <br />below toll-free numbers
                </div>
                <div class="expertPopUpBody">
                  <div class="expertPopUpDiv d-flex align-items-center pb-2 mb-2">
                    <div
                      class="expertPopUpIcons d-flex justify-content-center align-items-center mr-2"
                    >
                      <img
                        alt="Term Insurance"
                        src="https://static.pbcdn.in/term-cdn/images/images/headSetIcon.svg"
                        width="20"
                        height="20"
                      />
                    </div>
                    <div class="expertPopUpIconsTxt">
                      Looking To Buy ( Sales)
                      <div class="expertPopUpCallingNumber">
                        <a href="tel:1800-419-7713">1800-419-7713</a>
                      </div>
                    </div>
                  </div>
                  <div class="expertPopUpDiv d-flex align-items-center pb-2 mb-2">
                    <div
                      class="expertPopUpIcons d-flex justify-content-center align-items-center mr-2"
                    >
                      <img
                        alt="Term Insurance"
                        src="https://static.pbcdn.in/term-cdn/images/images/telePhoneIcon.svg"
                        width="20"
                        height="20"
                      />
                    </div>
                    <div class="expertPopUpIconsTxt">
                      Have Already Paid (Service)
                      <div class="expertPopUpCallingNumber">
                        <a href="tel:1800-258-5970">1800-258-5970</a>
                      </div>
                    </div>
                  </div>
                  <div class="expertPopUpDiv border-bottom-0 d-flex align-items-center mb-2">
                    <div
                      class="expertPopUpIcons d-flex justify-content-center align-items-center mr-2"
                    >
                      <img
                        alt="Term Insurance"
                        src="https://static.pbcdn.in/term-cdn/images/images/globalIcon.svg"
                        width="20"
                        height="20"
                      />
                    </div>
                    <div class="expertPopUpIconsTxt">
                      For NRI’s
                      <div class="expertPopUpCallingNumber">
                        <a href="tel:+91 124-6656508">+91 124-6656508</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="expertPopUpBtmTxt text-center">
                  Office Hours - 10:00 AM to 09:00 PM (IST)
                  <br />Use Registered No. Only*
                </div>
              </div>
            </div>
          </div>
        </em>
      </div>
    </header>

    <header v-if="isSpouse" class="header-mob spousehead">
      <div class="heads">
        <a class="logoimgs"></a>
        <div class="title">Spouse Term Insurance</div>
        <div @click="openTalktoExpertPopup" class="quotetop-rights">
          <em class="mobile_call">
            <img
              alt="Term Insurance"
              width="17"
              height="16"
              src="https://static.pbcdn.in/term-cdn/images/images/call-us.png"
            />
            <span class="txt">Call us</span>

            <div class="talkExpertPopUpBody" v-bind:class="{'show':talkToExpertPopupOpen}">
              <span class="close"></span>
              <i class="topIcon"></i>
              <div class="d-flex flex-column">
                <div class="expertPopupInnerBody">
                  <div class="expertPopUpDetails pb-2 mb-2">
                    You can reach us directly on the
                    <br />below toll-free numbers
                  </div>
                  <div class="expertPopUpBody">
                    <div class="expertPopUpDiv d-flex align-items-center pb-2 mb-2">
                      <div
                        class="expertPopUpIcons d-flex justify-content-center align-items-center mr-2"
                      >
                        <img
                          alt="Term Insurance"
                          src="https://static.pbcdn.in/term-cdn/images/images/headSetIcon.svg"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div class="expertPopUpIconsTxt">
                        Looking To Buy ( Sales)
                        <div class="expertPopUpCallingNumber">
                          <a href="tel:1800-419-7713">1800-419-7713</a>
                        </div>
                      </div>
                    </div>
                    <div class="expertPopUpDiv d-flex align-items-center pb-2 mb-2">
                      <div
                        class="expertPopUpIcons d-flex justify-content-center align-items-center mr-2"
                      >
                        <img
                          alt="Term Insurance"
                          src="https://static.pbcdn.in/term-cdn/images/images/telePhoneIcon.svg"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div class="expertPopUpIconsTxt">
                        Have Already Paid (Service)
                        <div class="expertPopUpCallingNumber">
                          <a href="tel:1800-258-5970">1800-258-5970</a>
                        </div>
                      </div>
                    </div>
                    <div class="expertPopUpDiv border-bottom-0 d-flex align-items-center mb-2">
                      <div
                        class="expertPopUpIcons d-flex justify-content-center align-items-center mr-2"
                      >
                        <img
                          alt="Term Insurance"
                          src="https://static.pbcdn.in/term-cdn/images/images/globalIcon.svg"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div class="expertPopUpIconsTxt">
                        For NRI’s
                        <div class="expertPopUpCallingNumber">
                          <a href="tel:+91 124-6656508">+91 124-6656508</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="expertPopUpBtmTxt text-center">
                    Office Hours - 10:00 AM to 09:00 PM (IST)
                    <br />Use Registered No. Only*
                  </div>
                </div>
              </div>
            </div>
          </em>
        </div>
      </div>
      <div class="spouse_img">
        <img alt="term" src="https://static.pbcdn.in/term-cdn/images/vue/spouse_mobile.png" />
        <div class="spouse_content_des">
          <p class="coverspouse">Cover Your Spouse!</p>
          <p>
            Give extra security for
            <br />your family’s future
          </p>
        </div>

        <div class="onlineIfo_section">
          <p class="online_discount">
            Discount of
            <strong>
              upto 10%
              <sup>#</sup>
            </strong>
          </p>
          <div class="covidInfo">COVID-19 Covered</div>
        </div>
      </div>
    </header>

    <!-- Talk to expert -->
    <!-- <modal
      class="modal-open"
      width="100%"
      height="100%"
      :adaptive="true"
      :clickToClose="true"
      :classes="['modal-open']"
      name="talk-to-expert"
    >
      <div id="emailModel">
        <div class="modal-content">
          <div class="modal-header"></div>
          <div class="modal-body">
            <button @click="hide" id="closeSidepage">X</button>
            <div class="callHeading">
              <span class="circle">
                <img
                  alt="circle"
                  src="data:image/svg+xml;base64,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"
                />
              </span>
              <h3
                v-bind:class="{'talkexpert':!talkToExpertCalled}"
              >{{talkToExpertCalled ? 'We will call you back!' : 'You can talk to us directly on below toll free numbers'}}</h3>
            </div>
            <div class="callContaint">
              <p
                v-bind:class="{'hidetalkexpert':!talkToExpertCalled}"
              >You can reach us directly on the below toll-free numbers:</p>
              <ul>
                <li>
                  <label>Looking To Buy ( Sales)</label>
                  <a href="tel:1800-208-8787" v-if="!isQuotesPage">
                    <img
                      alt="call"
                      src="data:image/svg+xml;base64,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"
                    />
                    1800-208-8787
                  </a>
                  <template v-else>
                    <a href="tel:1800-419-7713">
                      <img
                        alt="call"
                        src="data:image/svg+xml;base64,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"
                      />
                      1800-419-7713
                    </a>
                  </template>
                </li>
                <li>
                  <label>Have Already Paid (Service)</label>
                  <a href="tel:1800-258-5970">
                    <img
                      alt="call"
                      src="data:image/svg+xml;base64,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"
                    />
                    1800-258-5970
                  </a>
                </li>
                <li>
                  <label>For NRI's</label>
                  <a href="tel:+91 124-6656508">
                    <img
                      alt="call"
                      src="data:image/svg+xml;base64,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"
                    />
                    +91 124-6656508
                  </a>
                </li>
              </ul>
              <p class="copy">Use Registered No. Only*</p>
            </div>
          </div>
        </div>
      </div>
    </modal> -->
  </div>
</template>

<script lang="ts">
/* tslint:disable */

import { computed, defineComponent, ref} from 'vue';
import { useRoute } from 'vue-router';
import prequotesService from "../services/prequotesService";
import appFixedDiv from "@/common/directives/appFixedDiv";
import environment from "@/environment";
import analyticsService from "@/services/analyticsService";

export default defineComponent({
  name: 'HeaderComponent',
  directives: {
    appFixedDiv,
  },
  props: {
    mobileDevice: {
      type: Boolean,
      default: false,
    },
    isposp: {
      type: Boolean,
      default: false,
    },
    isSpouse: {
      type: Boolean,
      default: false,
    },
    isWomen: {
      type: Boolean,
      default: false,
    },
    isNri: {
      type: Boolean,
      default: false,
    },
    utmSource: {
      type: String,
      default: '',
    }
  },
  setup(props){
     const openTalkToExp = ref(false);
     const prefilldata = ref(null);
     const isQuotesPage = ref(false);
     const talkToExpertCalled = ref(false);
     const talkToExpertPopupOpen = ref(false);
     const route = useRoute(); // Access the current route

      const openTalktoExpertPopup = ()=> {
        talkToExpertPopupOpen.value = !talkToExpertPopupOpen.value;
      }
     const openTalktoExpert = () =>  {
      isQuotesPage.value = route.query["enquiryId"] != undefined;
      talkToExpertCalled.value = false;
      prefilldata.value = prequotesService.prefillprequotedata;
      if (
        prefilldata.value &&
        prefilldata.value["matrixLeadId"] &&
        prefilldata.value["encryptedMobileNo"] &&
        prequotesService.checkForClickToCall(prefilldata.value["matrixLeadId"])
      ) {
        talkToExpertCalled.value = true;
        prequotesService
          .clickToCall(
            prefilldata.value["encryptedMobileNo"],
            prefilldata.value["matrixLeadId"]
          )
          .then((response: any) => {
            prequotesService.setExpertClickToCallCookie(
              prefilldata.value!["matrixLeadId"]
            );
          });
      }
      // this.$modal.show("talk-to-expert"); // Need to change 
    }

     const closeTalkToExp = (event:any) => {
      event.stopPropagation();
      openTalkToExp.value = false;
    };

    const hide = () => {
      // Example of using this.$modal.hide('talk-to-expert');
      // this.$modal.hide("talk-to-expert");
    };
    const getPolicyHyperLink = () => {
      return props.isposp ? '' : 'https://www.policybazaar.com';
    };
    const getTermDecalLik = environment.termClaim;
    const onClaimClick = () => {
      analyticsService.setGtmdata('prequotes', 'claimassistance', null);
    };

   const isCrmLink = computed(() => {
      return (
        route.query.isCrm &&
        route.query.isCrm === 'true'
      );
    });  
     // Return all methods and properties
    return {
      openTalkToExp,
      prefilldata,
      isQuotesPage,
      talkToExpertCalled,
      talkToExpertPopupOpen,
      openTalktoExpertPopup,
      openTalktoExpert,
      closeTalkToExp,
      hide,
      getPolicyHyperLink,
      getTermDecalLik,
      onClaimClick,
      isCrmLink
    };
    
  },
   methods:{
      isMobiledevice(){
        return this.mobileDevice;
      }
    }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.prequotes{
  overflow: hidden;

}

.prequotes .headers {
  width: 100%;
  float: left;
  background: var(--bgWColor2);
 
  border: 0;
  padding-top: 0px;
  height: 48px;
  
  top: 0;
  z-index: 999;
  transition: all 0.5s ease;
  box-shadow: 0 1px 10px rgb(0 0 0 / 10%);
  display: flex;
  align-items: center;
}

.prequotes .containers {
  width: 1080px;
  margin: 0 auto;
  max-width: 100%;
}

.head_desk {
  display: flex;
  justify-content: space-between;
}

.prequotes .headers.fixed {
  position: fixed;
  animation: headerAnimation 0.6s forwards;
  padding-top: 2px;
  background: #fff;
  z-index: 999;
}

.logopb {
  width: 152px;
  float: left;
  background: var(--logos)
    no-repeat 0px -2px;
  height: 40px;
  background-size: cover;
}

.pbcontact .icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  float: left;
  position: relative;
  top: 5px;
  right: 0;
  background-position: 9px -34px !important;
  background: url(https://static.pbcdn.in/term-cdn/images/images/psprite-icon.svg);
}

.talkExpertPopUpBody .close {
  right: 4px;
  top: 10px;
}
.mb-2,
.my-2 {
  margin-bottom: 10px;
}
.topIcon,
.topIcon:after {
  box-shadow: none;
  right: 35px;
  left: auto;
}
.topIcon:after {
  display: none;
}
.expertPopUpCallingNumber {
  font-size: 13px;
}
.talkExpertPopUpBody {
  width: 270px;
  top: 13px;
  right: 4px;
  padding: 30px 10px 15px;
}
.talkExpertPopUpBody.show {
  right: 0px;
}
.mobile_call img {
  top: 8px;
  width: 20px;
  height: 17px;
  padding-right: 3px;
}
.expertPopUpBtmTxt {
  margin-left: -10px;
  margin-right: -10px;
  margin-bottom: -16px;
  padding: 15px;
}

.claim-ratio .icon {
  background: url(https://static.pbcdn.in/term-cdn/images/images/psprite-icon.svg);
  top: 0;
  right: 4px;
  background-position: 0 -2px;
  background-size: 46px;
  width: 32px;
  height: 20px;
}

.flex-column {
  -ms-flex-direction: column;
  flex-direction: column;
}
.d-flex {
  display: -ms-flexbox;
  display: -moz-box-flexbox;
  display: -webkit-flex;
  display: flex;
}
.expertPopUpDetails {
  font-size: 12px;
  line-height: 1.92;
  text-align: center;
 color: var(--experttextcolor);
    border-bottom: solid 1px var(--bordersidecolor);
}
.pb-2,
.py-2 {
  padding-bottom: 15px;
}
.mb-2,
.my-2 {
  margin-bottom: 15px;
}
.expertPopUpDiv {
  border-bottom: solid 1px var(--bordersidecolor);
  align-items: center;
  padding-bottom: 20px;
}

.topIcon,
.topIcon:after {
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  position: absolute;
  top: -10px;
  left: 50%;
 box-shadow: 0 8px 19px 0 var(--white);
  border-bottom: 10px solid var(--white);
  width: 10px;
}

.topIcon:after {
  content: "";
  top: 1px;
  left: -10px;
  border-bottom: 10px solid #fff;
}

.close {
  position: absolute;
  right: 5px;
  cursor: pointer;
  top: -5px;
  width: 32px;
  height: 32px;
  opacity: 0.5;
  background: transparent;
  border: 0;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: " ";
  height: 18px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}

.expertPopUpBody a {
  color: var(--plancolor2);
  text-decoration: none;
  font-size: 15px;
}

.expertPopUpIconsTxt {
  font-size: 12px;
  line-height: 2.33;
  text-align: left;
  color: var(--experttextcolor);
}
.expertPopUpCallingNumber {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.56;
  text-align: left;
  color: #0077ff;
}

.expertPopUpDiv:last-child {
  border-bottom: 0;
}

.talkExpert {
  font-size: 12px;
  font-weight: 600;
  line-height: 2.33;
  text-align: left;
  color: #0065ff;
  cursor: pointer;
}



.talkExpertPopUpBody.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(10px);
  position: absolute;
  top: 28px;
  right: -120px;
  z-index: 9999;
}



.topIcon:after {
  content: "";
  top: 1px;
  left: -10px;
  border-bottom: 10px solid #fff;
}

.expertPopUpIcons {
  width: 43px;
  height: 43px;
  border-radius: 50%;
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}

.popUpBtmTxt {
  font-size: 0.625rem;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: normal;
  text-align: left;
  color: #2c3e50;
}

.popUpTopIcon {
  background-color: #2c3e50;
  width: 3.75rem;
  height: 3.75rem;
  top: -66px;
  border: solid 4px #ffffff;
}

.expertPopUpBtmTxt {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: var(--comparetxtcolor);
  background-color: var(--expertbgcolor);
  margin-left: -30px;
  margin-right: -30px;
  margin-bottom: -30px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 15px;
  text-align: center;
}

@keyframes headerAnimation {
  0% {
    -webkit-transform: translateY(-160px);
    transform: translateY(-160px);
  }
  100% {
    -webkit-transform: translateY(0);
    box-shadow: 0 2px 30px 1px #dbdde1;
    transform: translateY(0);
  }
}

.prequotes .formbox-inner {
  width: 100%;
  float: left;
  position: relative;
  height: 560px;
  background: var(--white);
  box-shadow: 0 1px 30px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  margin-top: 26px;
}

.prequotes .logo {
  float: left;
  padding: 0;
  width: 75%;
  position: relative;
  z-index: 1;
}

.prequotes .logo img {
  margin-top: 3px;
  max-width: 154px;
}

.prequotes .claim-ratio {
  float: left;
  padding-top: 7px;
  padding-left: 20px;
  text-align: right;
  height: 34px;
  width: auto;
}

.icon {
  display: inline-block;
}

.claim-ratio .icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  float: left;
  position: relative;
  top: 0;
  right: 7px;
  background-position: 0px -2px;
  background-size: 46px;
}
.pbcontact .icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  float: left;
  position: relative;
  top: 5px;
  right: 0;
  background-position: 6px -39px;
  background-size: 56px;
}

.flex-column {
  -ms-flex-direction: column;
  flex-direction: column;
}
.d-flex {
  display: -ms-flexbox;
  display: -moz-box-flexbox;
  display: -webkit-flex;
  display: flex;
}
.expertPopUpDetails {
  font-size: 12px;
  line-height: 1.92;
  text-align: center;
 color: var(--experttextcolor);
    border-bottom: solid 1px var(--bordersidecolor);
  font-weight: 400;
}
.pb-2,
.py-2 {
  padding-bottom: 20px;
}
.mb-2,
.my-2 {
  margin-bottom: 20px;
}
.expertPopUpDiv {
  border-bottom: solid 1px var(--bordersidecolor);
  align-items: center;
}

.expertPopUpBody a {
  color: var(--plancolor2);
  text-decoration: none;
  font-weight: 600;
}
.expertPopUpDiv .expertPopUpIcons img {
  
    filter: var(--filterbrighticon);
}

.expertPopUpIconsTxt {
  font-size: 12px;
  line-height: 2.33;
  text-align: left;
  color: var(--experttextcolor);
  font-weight: normal;
}
.expertPopUpCallingNumber {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.56;
  text-align: left;
  color: #0077ff;
}

.expertPopUpDiv:last-child {
  border-bottom: 0;
}

.talkExpert {
  font-size: 12px;
  font-weight: 600;
  line-height: 2.33;
  text-align: left;
  color: #0065ff;
  cursor: pointer;
}

.talkExpertPopUpBody {
  padding: 30px;
  width: 320px;
  position: absolute;
  /* transform: translateY(-10px); */
  opacity: 0;
  visibility: hidden;
  z-index: 10;
  /* transition: all 0.3s linear; */
  box-shadow: 0 8px 50px 0 var(--experdshadow);
  background-color: #ffffff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  right: -90px;
  top: 40px;
}

.talkExpertPopUpBody.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(10px);
  position: absolute;
  border-radius: 8px;
  top: 30px;
  right: -90px;
  z-index: 9999;
  background: var(--white);
}



.topIcon:after {
  content: "";
  top: 1px;
  left: -10px;
  border-bottom: 10px solid #fff;
}

.expertPopUpIcons {
  width: 43px;
  height: 43px;
  border-radius: 50%;
  background-color: var(--expertbgcolor);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
}

.popUpBtmTxt {
  font-size: 0.625rem;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: normal;
  text-align: left;
  color: #2c3e50;
}

.popUpTopIcon {
  background-color: #2c3e50;
  width: 3.75rem;
  height: 3.75rem;
  top: -66px;
  border: solid 4px #ffffff;
}

.expertPopUpBtmTxt {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: var(--comparetxtcolor);
  background-color: var(--expertbgcolor);
  margin-left: -30px;
  margin-right: -30px;
  margin-bottom: -30px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 15px;
  text-align: center;
}

.prequotes .claim-ratio .icons {
  display: inline-block;
  width: 30px;
  height: 30px;
  float: left;
  position: relative;
  top: 0;
  right: 4px;
  background-position: 0px -2px;
  background-size: 46px;
  background: var(--compare_page_callicon);
}

.prequotes .claim-ratio a {
  padding-top: 0px;
  display: inline-block;
  letter-spacing: 0;
  height: 36px;
  text-decoration: none;
  cursor: pointer;
  color: #0065ff;
  font-size: 12px;
  font-style: normal;
  line-height: 27px;
  font-weight: 600;
}

.circle {
  background-color: #ffffff;
  border: 0;
  width: 38px;
  height: 38px;
  float: right;
  margin-top: 5px;
}
.circle {
  background-color: #d5e6ff;
  border: 10px solid #e9f2ff;
  width: 50px;
  height: 50px;
  float: none;
}

.prequotes .claim-ratio a {
  padding-top: 0px;
  display: inline-block;
  letter-spacing: 0;
  height: 36px;
  text-decoration: none;
  cursor: pointer;
  color: var(--plancolor2);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
}

.prequotes .claim-ratio a img {
  float: left;
  position: relative;
  top: 0;
  right: 8px;
}

.prequotes .quotetop-rights {
  float: left;
  padding-left: 2%;
  width: 10%;
  height: 30px;
}

.prequotes .quotetop-rights .call_icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  float: left;
  position: relative;
  top: 5px;
  right: 0;
  background: var(--compare_page_callicon);
  background-position: 6px -39px;
  background-size: 56px;
}

.prequotes .pbcontact {
  float: left;
  width: 100%;
  height: 35px;
  padding-top: 4px;
  position: relative;
}

.prequotes .pbcontact .tool-icon {
  float: left;
  padding: 7px 0 6px 10px;
}

.prequotes .pbcontact .phone_icon {
  float: left;
  padding-left: 8px;
  font-weight: 600;
  padding-top: 7px;
  cursor: pointer;
  color: var(--plancolor2);
  position: relative;
  font-size: 12px;
}

i {
  font-style: normal;
}

.top-title {
  width: 65%;
  float: left;
  padding-left: 22px;
}

.top-title h2 {
  text-align: center;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
  padding-top: 10px;
}

.prequotes .toll-free {
  float: left;
  padding-top: 14px;
  width: 100%;
}

.prequotes .toll-free .number-infos {
  position: absolute;
  right: -1px;
  opacity: 0;
  visibility: hidden;
  top: 37px;
  background: #fff;
  width: 228px;
  padding: 0;
  box-shadow: 0 2px 13px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.prequotes .quotetop-rights:hover .number-infos {
  border: 1px solid #0652dd;
  opacity: 1;
  z-index: 999;
  visibility: visible;
}

.footer {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 10px;
  margin-top: 25px;
}

.footer p {
  margin: 0;
  color: var(--footertext);
  line-height: 16px;
  font-size: 9px;
}

.footer p a {
  color: #157bfb;
  text-decoration: none;
  font-weight: 400;
}

.header-mob {
  display: none;
}

@media (min-width: 320px) and (max-width: 1024px) {
  .online_discount {
    display: inline-block;
    height: 24px;
    background: #e5ffef;
    padding: 3px 5px 3px;
    color: #253858;
    border-radius: 8px 8px 0 0;
    font-size: 10px;
    font-weight: normal;
    width: auto;
    text-align: left;
  }
  .onlineIfo_section {
    display: flex;
    position: absolute;
    bottom: 12px;
    justify-content: flex-start;
    align-items: flex-end;
    width: 100%;
    float: left;
    margin-top: 4px;
  }
  .covidInfo {
    width: 146px !important;
    height: 24px;
    font-weight: 600;
    margin-left: 5px;
    background: #ffe5ef;
    border-radius: 8px 8px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 5px 3px;
    font-size: 10px;
    color: var(--blacktext);
  }
  .covidInfo img {
    margin-right: 10px;
  }

  body {
    margin: 0;
  }

  .close {
    position: absolute;
    right: 5px;
    cursor: pointer;
    top: -5px;
    width: 32px;
    height: 32px;
    opacity: 0.5;
    background: transparent;
    border: 0;
  }
  .close::before,
  .close::after {
    position: absolute;
    left: 15px;
    content: " ";
    height: 18px;
    width: 2px;
    background-color: var(--border_color);
  }
  .close::before {
    transform: rotate(45deg);
  }
  .close::after {
    transform: rotate(-45deg);
  }

  .prequotes {
    background: #fff;
  }

  .prequotes .right-section {
    width: 100%;
  }

  .logoimgs {
    width: 30px;
    height: 30px;
    background: url(https://static.pbcdn.in/term-cdn/images/images/logosprite@2x.png)
      no-repeat -152px 3px;
    background-size: cover;
    display: inline-block;
  }
  .heads {
    width: 100%;
    float: left;
    padding: 0 10px;
  }

  .spouse_img {
    position: relative;
    width: 100%;
    float: left;
    height: calc(100% - 35px);
  }
  .spouse_img .getDisc {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #3ba6f4;
    border-radius: 0px 0px 12px 0px;
    width: 205px;
    height: 23px;
  }
  .spouse_img .getDisc h2 {
    font-size: 10px;
    color: #ffffff;
    font-weight: normal;
    display: flex;
  }
  .spouse_img .getDisc h2 img {
    width: 13px;
    margin-right: 2px;
  }
  .spouse_img .getDisc h2 .whiteStar {
    left: 0;
    top: -3px;
  }
  .spouse_content_des {
    position: absolute;
    top: 20%;
    left: 8px;
  }
  .spouse_content_des p.coverspouse {
    font-size: 1.2em;
    font-weight: 600;
    text-align: center;
  }
  .spouse_content_des p {
    font-weight: 500;
    font-size: 1em;
    color: #212529;
    text-align: center;
  }

  .prequotes .spousehead.header-mob {
    background: #fff;
    box-shadow: none;
    padding: 0px;
    height: 200px;
  }

  .spousehead .title {
    text-align: left;
    width: 100%;
    float: left;
    position: absolute;
    text-transform: none;
    font-weight: 500;
    top: 8px;
    left: 45px;
    width: calc(100% - 48px);
    color: #000 !important;
    font-size: 13px;
    padding-top: 0;
  }

  .prequotes .header-mob {
    display: block;
    padding: 0px 4px 0 6px;
    background: var(--juranypointbg);
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.5);
    height: 40px;
  }

  .prequotes .header-mob a.logoimg {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: url(https://static.pbcdn.in/term-cdn/images/images/logosprite@2x.png)
      no-repeat -152px 3px;
    background-size: cover;
  }

  .title {
    text-align: center;
    width: 100%;
    float: left;
    color: #fff;
    position: absolute;
    text-transform: uppercase;
    padding-top: 11px;
    font-size: 12px;
    left: 0;
  }
  .prequotes .loader {
    top: 150px;
  }

  .mobile_call {
    color: #a1bdec;
    height: 35px;
    font-style: normal;
    line-height: 35px;
    font-size: 10px;
  }
  .talkExpertPopUpBody .close {
    right: 4px;
    top: 8px;
  }
  .mb-2,
  .my-2 {
    margin-bottom: 10px;
  }
  .topIcon,
  .topIcon:after {
    box-shadow: none;
    right: 35px;
    left: auto;
  }
  .topIcon:after {
    display: none;
  }
  .expertPopUpCallingNumber {
    font-size: 13px;
  }
  .talkExpertPopUpBody {
    width: 270px;
    top: 13px;
    right: 4px;
    padding: 30px 10px 15px;
  }
  .talkExpertPopUpBody.show {
    right: 4px;
    top: 38px;
  }
  .mobile_call img {
    top: 8px;
    width: 20px;
    height: 17px;
    padding-right: 3px;
  }
  .expertPopUpBtmTxt {
    margin-left: -10px;
    margin-right: -10px;
    margin-bottom: -16px;
    padding: 15px;
  }

  .prequotes .quotetop-rights {
    width: auto;
    padding-left: 0;
    padding-right: 8px;
    float: right;
    position: relative;
    z-index: 9999;
  }

  .prequotes .w--spinner > div {
    width: 8px;
    height: 8px;
  }
  .prequotes .quotetop-rights {
    float: right;
    /* widt: 20%; */
  }

  .prequotes .pbcontact {
    padding-top: 0;
  }

  .prequotes .headers {
    display: none;
  }

  .prequotes .formbox-inner {
    margin-top: 0;
    box-shadow: none;
    background: 0 0;
  }

  .mobile_call {
    height: 41px;
    display: block;
    top: 0;
    width: 100%;
    padding: 4px 0 0;
    border-radius: 0;
    font-size: 10px;
  }

  .mobile_call img {
    position: relative;
    float: left;
    width: 16px;
    right: -9px;
    top: 8px;
    filter: brightness(0) invert(1);
  }

  .expertPopUpIcons img {
    top: 0;
    right: 0;
  }

  .mobile_call span.txt {
    display: inline-block;
    float: left;
    text-align: left;
    position: relative;
    top: 10px;
    left: 10px;
    width: 48px;
    line-height: 12px;
    font-weight: 500;
    font-size: 11px;
    font-style: normal;
    color: #fff;
  }

  .spouse_img img {
    width: 100%;
    height: 187px;
  }
}

@media (max-width: 360px) {
  .prequotes .quotetop-rights {
    width: 25%;
  }
}

a {
  color: #42b983;
}

#emailModel {
  width: 675px;
  margin: 80px auto 0;
  min-height: 338px;
  background: #fbfbfb;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.modal-header {
  display: none;
}
.callHeading {
  width: 80%;
  margin: 8px auto 0;
  text-align: center;
  border-bottom: 1px solid #dcdcdc;
  box-sizing: content-box;
}
.circle {
  position: relative;
  background-color: #d5e6ff;
  border: 10px solid #e9f2ff;
  width: 50px;
  height: 50px;
  border-radius: 100px;
  display: inline-block;
  box-sizing: content-box;
}
.circle img {
  position: absolute;
  text-align: center;
  top: 15px;
  left: 15px;
}
.callHeading h3 {
  text-align: center;
  font-size: 24px;
  color: #2684ff;
  padding: 14px 0 25px;
  font-weight: 600;
}
.callContaint {
  text-align: center;
  width: 100%;
  float: left;
}
.callContaint p {
  color: #212121;
  font-size: 16px;
  font-weight: 500;
  margin: 20px 0 10px;
}
.callContaint ul {
  width: 100%;
  float: left;
  margin: 10px 0;
  margin-left: 4%;
}
.callContaint ul li {
  list-style: none;
  float: left;
  width: 33%;
}
.callContaint ul li label {
  display: block;
  text-align: left;
  margin-bottom: 7px;
  color: #212121;
  font-size: 13px;
  font-weight: 500;
}
.callContaint ul li a {
  cursor: pointer;
  text-align: left;
  display: block;
  color: #2684ff;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
}
.callContaint ul li a img {
  position: relative;
  top: -1px;
  max-width: 16px;
  left: -1px;
}
.copy {
  width: 100%;
  float: left;
  margin: 30px 0 0px !important;
  text-align: center;
  font-size: 12px !important;
  color: #696969 !important;
}
.callHeading .talkexpert {
  font-size: 18px;
}
.hidetalkexpert {
  display: none;
}

#emailModel .modal-body #closeSidepage {
  float: right;
  cursor: pointer;
  border: 0;
  font-size: 16px;
  font-weight: 600;
  border-radius: 100%;
  width: 25px;
  height: 25px;
  padding: 2px;
  background: transparent;
  color: var(--closepopupcolor);
  position: absolute;
  right: 3px;
  top: 2px;
}
#emailModel {
  -webkit-animation-duration: 0.85s;
  animation-duration: 0.85s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
}

@keyframes bounceInUp {
  0%,
  30%,
  60%,
  80%,
  100% {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 200px, 0);
    transform: translate3d(0, 200px, 0);
  }
  30% {
    opacity: 1;
    -webkit-transform: translate3d(0, -40px, 0);
    transform: translate3d(0, -40px, 0);
  }
  60% {
    -webkit-transform: translate3d(0, 4px, 0);
    transform: translate3d(0, 4px, 0);
  }
  80% {
    -webkit-transform: translate3d(0, -2px, 0);
    transform: translate3d(0, -2px, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@-webkit-keyframes bounceInUp {
  0%,
  30%,
  60%,
  80%,
  100% {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 200px, 0);
    transform: translate3d(0, 200px, 0);
  }
  30% {
    opacity: 1;
    -webkit-transform: translate3d(0, -40px, 0);
    transform: translate3d(0, -40px, 0);
  }
  60% {
    -webkit-transform: translate3d(0, 4px, 0);
    transform: translate3d(0, 4px, 0);
  }
  80% {
    -webkit-transform: translate3d(0, -2px, 0);
    transform: translate3d(0, -2px, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@media all and (min-width: 320px) and (max-width: 1024px) {
  .header-mob.womenHeaader {
    background: var(--bgWColor2);
  }
  .header-mob.womenHeaader .title {
    padding-left: 45px;
    text-align: left;
    color: var(--themecolor);
    font-size: 14px;
    font-weight: 500;
    text-transform: capitalize;
  }
  .header-mob.womenHeaader .logo {
    padding: 5px 0 0;
    width: 45%;
  }
  .header-mob.womenHeaader .mobile_call {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
    border-radius: 0;
    font-size: 10px;
    border: 1px solid #e2e2e2;
    height: 28px;
    line-height: 25px;
    border-radius: 8px;
    width: 117px;
    text-align: center;
    font-size: 11px;
    margin-top: 7px;
  }
  .header-mob.womenHeaader .mobile_call span.txt {
    left: auto;
    top: auto;
    width: 100%;
    text-align: center;
    color: var(--bluecolor);
  }
  .header-mob.womenHeaader .mobile_call img {
    width: 15px;
    top: 0;
    right: auto;
    left: 5px;
  }
  .header-mob.womenHeaader .quotetop-rights {
    float: right;
    width: 125px;
    padding-right: 0;
    z-index: 999;
  }

  .header-mob.womenHeaader .mobile_call .expertPopupInnerBody img {
    width: 20px;
    left: 2px;
  }

  .prequotes .logo img {
    margin-top: 0;
  }
  #emailModel {
    width: 96%;
  }
  .modal-body {
    padding: 0 10px;
  }
  .callHeading .talkexpert {
    font-size: 14px;
    font-weight: normal !important;
  }
  .circle img {
    text-align: center;
    top: 10px;
    left: 9px;
    width: 16px;
  }
  .modal-body #closeSidepage {
    right: -7px;
    top: -5px;
  }
  .circle {
    background-color: #fff;
    border: 0;
    width: 34px;
    height: 34px;
    margin-top: 3px;
  }
  .callHeading {
    width: 90%;
  }
  .callHeading h3 {
    font-size: 18px;
    padding: 14px 0 16px;
    font-weight: 600 !important;
  }
  .callContaint p {
    font-size: 12px;
    margin: 20px 0 20px;
  }
  .callContaint ul {
    margin-left: 10px;
  }
  .callContaint ul li {
    margin-bottom: 5px;
    width: 50%;
  }
  .callContaint ul li label {
    font-size: 11px;
    margin-bottom: 4px;
    font-weight: 600;
  }
  .copy {
    margin: 0px 0 13px !important;
    font-size: 9px !important;
  }
  .callContaint ul li a {
    font-size: 16px;
    font-weight: 600;
  }
  .callContaint ul li a img {
    max-width: 13px;
  }
  .callContaint ul li:last-child {
    width: 90%;
    margin-top: 20px;
  }
  .callContaint ul li:last-child label {
    text-align: center;
  }
  .callContaint ul li:last-child a {
    text-align: center;
  }
}

@media (max-width: 360px) {
  .callContaint ul li label {
    font-size: 10px;
  }
}

@media (max-width: 320px) {
  .modal-body {
    padding: 0;
  }
  #emailModel {
    width: 97%;
    padding: 10px 5px;
  }
  .callContaint ul li label {
    font-size: 10px;
    margin-bottom: 3px;
  }
  .callContaint ul li a {
    font-size: 12px;
  }
}
</style>